import { DataObject } from '@/utils/DataObject'
import { Gallery } from './Gallery'
import { Artwork } from '../artwork/Artwork'
import { ArtworkTransformer } from '../artwork/ArtworkTransformer'
import { Media } from '../media/Media'
import { MediaTransformer } from '../media/MediaTransformer'

export class GalleryTransformer {

  private parseMedia (data: DataObject = {}): Media {
    if (data.media) {
      return new MediaTransformer().toClass(data.media)
    }
    return new Media()
  }

  public toClass (data: DataObject = {}): Gallery {
    return new Gallery({
      id: data.id || '',
      name: data.name || '',
      about: data.about || '',
      slug: data.slug || '',
      description: data.description || '',
      phone: data.phone || '',
      email: data.email || '',
      street: data.street || '',
      post_code: data.post_code || '',
      city: data.city || '',
      web_page: data.web_page || '',
      web_page_label: data.web_page_label || '',
      exhibition_artist: data.exhibition_artist || '',
      exhibition_name: data.exhibition_name || '',
      exhibition_description: data.exhibition_description || '',
      physical_from: data.physical_from || null,
      physical_till: data.physical_till || null,
      exhibition_from: data.exhibition_from || null,
      exhibition_till: data.exhibition_till || null,
      media: this.parseMedia(data),
      artworks: data.artworks ?
        data.artworks.map((artwork: Artwork) => new ArtworkTransformer().toClass(artwork))
        : [],
    })
  }

}
